import { Spin, Table } from 'antd';

import type { ModelProductUnit } from '@app/api/Products';
import { useWindowSize } from '@app/hooks';
import { PF } from '@app/pages/Warehouses/GoodsUnits/data';
import type { GoodsUnitTableType } from '@app/pages/Warehouses/GoodsUnits/types';

const TABLE = `${PF}_table`;

export const GoodsUnitsTable: GoodsUnitTableType = ({
  isPageLoading,
  isFetching,
  data,
  columns,
  pagination: { ItemsPerPage, PageN, Total },
  onPaginate,
  onPageSizeChange,
}) => {
  const { isMobile } = useWindowSize();

  const from = Total === 0 ? 0 : (PageN - 1) * ItemsPerPage + 1;
  const to = Total === 0 ? 0 : Math.min(PageN * ItemsPerPage, Total);

  if (isPageLoading) {
    return (
      <div className={`${TABLE}_loading`}>
        <Spin spinning />
      </div>
    );
  }

  return (
    <div className={`${TABLE}_container`}>
      <div className={`${TABLE}_content`}>
        <Table<ModelProductUnit>
          columns={columns}
          dataSource={data}
          rowKey={({ Id }) => Id}
          pagination={
            Total > 0
              ? {
                  responsive: true,
                  current: PageN,
                  total: Total,
                  pageSize: ItemsPerPage,
                  showSizeChanger: true,
                  showLessItems: isMobile,
                  size: isMobile ? 'small' : 'default',
                  position: isMobile ? ['bottomCenter'] : ['bottomLeft'],
                  onChange: onPaginate,
                  onShowSizeChange: (_, pageSize) => onPageSizeChange(pageSize),
                  showTotal: (itemsTotal) =>
                    isMobile
                      ? `Всего ${itemsTotal}`
                      : `Показаны результаты с ${from} по ${to} из ${itemsTotal}`,
                }
              : false
          }
          size={isMobile ? 'small' : 'middle'}
          loading={isFetching}
          scroll={{ x: 'max-content' }}
          className={`${TABLE}_grid`}
        />
      </div>
    </div>
  );
};
